import FeeScheduleCategoryCommand, {
  FeeScheduleCategoryCommandPayload,
} from "marketplace/teams/fee-schedules/_api/commands/fee-schedule-category-command";
import FeeSchedule from "marketplace/teams/fee-schedules/fee-schedule";

export type FeeScheduleCommandPayload = {
  name: string;
  tags: string[];
  categories: FeeScheduleCategoryCommandPayload[];
};

export default class FeeScheduleCommand {
  name: string;
  tags: string[];
  categories: FeeScheduleCategoryCommand[];

  /**
   * The request body, as a plain object.
   *
   * RTK Query serializes a body only when it recognizes it as JSON — a plain object, an array, or
   * something with a `toJSON`. Handed the command instance itself it does the opposite: it drops the
   * declared Content-Type and passes the object to `fetch`, which sends the string `[object Object]`
   * as `text/plain`, and the API answers 415 before the action ever runs.
   */
  public get payload(): FeeScheduleCommandPayload {
    return {
      name: this.name,
      tags: this.tags,
      categories: this.categories.map((category) => category.payload),
    };
  }

  constructor(feeSchedule: FeeSchedule) {
    this.name = feeSchedule.name;
    this.tags = feeSchedule.tags.map(tag => tag.value) ?? [];
    this.categories =
      feeSchedule.categories?.map(
        (category) => new FeeScheduleCategoryCommand(category)
      ) ?? [];
  }
}
